const baseColumnDefs = [
  {
    headerName: 'SecurityId',
    field: 'securityId',
    width: 100,
  },
  {
    headerName: 'Exchange',
    field: 'exchangeCode',
    width: 160,
    tooltipField: 'exchangeCode',
  },
  { headerName: 'Asset Class', field: 'assetClass', width: 80 },
  { headerName: 'Inst Class', field: 'instrumentClass', width: 80 },
  {
    headerName: 'BB_TCM',
    field: 'ticker',
    width: 180,
    tooltipField: 'ticker',
  },
  {
    headerName: 'Name',
    field: 'securityCode',
    width: 160,
    tooltipField: 'securityDesc',
  },
  {
    headerName: 'Desc',
    field: 'securityDesc',
    width: 200,
    tooltipField: 'securityDesc',
  },
  {
    headerName: 'Identifiers',
    field: 'identifiers',
    width: 80,
    filter: false,
    cellRenderer: 'AgEditCellRenderer',
    cellRendererParams: {
      editButton: 'Identifiers',
    },
  },
  {
    headerName: 'Action',
    field: 'edit',
    width: 80,
    filter: false,
    cellRenderer: 'AgEditCellRenderer',
    cellRendererParams: {
      editButton: 'Edit',
    },
  },
]

const buildCcyColumnDefs = ({ onIdentifiers, onEdit }) =>
  baseColumnDefs.map((col) => {
    if (col.field === 'identifiers') {
      return {
        ...col,
        cellRendererParams: {
          ...col.cellRendererParams,
          showEditModal: onIdentifiers,
        },
      }
    }
    if (col.field === 'edit') {
      return {
        ...col,
        cellRendererParams: {
          ...col.cellRendererParams,
          showEditModal: onEdit,
        },
      }
    }
    return col
  })

export { baseColumnDefs, buildCcyColumnDefs }
